/**
 * i18n Module
 * Initializes and configures i18next for React
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { i18nConfig } from './i18n.config';
import { sharedResources } from '../app/i18n';

// All translations are in app/i18n
const resources = {
  en: {
    common: sharedResources.en.common,
    validation: sharedResources.en.validation,
    errors: sharedResources.en.errors,
  },
  uk: {
    common: sharedResources.uk.common,
    validation: sharedResources.uk.validation,
    errors: sharedResources.uk.errors,
  },
};

i18n
  // Load translation using http backend (for public/locales)
  .use(Backend)
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  .init({
    ...i18nConfig,
    resources,
    compatibilityJSON: 'v3',
    // Use resources from code if available, otherwise load from backend
    partialBundledLanguages: true,
  });

export default i18n;
